import component from './Component'

export default component
